"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityManagementMessages = void 0;
const common_1 = require("@reality/messenger/lib/common");
const t = __importStar(require("io-ts"));
const index_1 = require("./index");
exports.EntityManagementMessages = {
    CreateEntity: new common_1.MessageDefinition("CreateEntity", t.type({
        entityId: t.string,
        instanceId: t.string,
        sharedStore: t.unknown,
        entityState: index_1.EntityStateCodec,
    })),
    DestroyEntity: new common_1.MessageDefinition("DestroyEntity", t.type({
        instanceId: t.string,
    })),
    RequestStateChange: new common_1.MessageDefinition("RequestStateChange", t.type({
        instanceId: t.string,
        requestedState: index_1.EntityStateCodec,
        requestedAnimation: t.union([t.string, t.undefined]),
    })),
    StateUpdate: new common_1.MessageDefinition("StateUpdate", t.type({
        instanceId: t.string,
        entityState: index_1.EntityStateCodec,
        animation: t.union([t.string, t.undefined]),
    })),
};
// ------------------------------------------------
// export const SharedStoreUpdate = MessageDefinition.new("SharedStoreUpdate", t.type({
//   instanceId: t.string,
//   sharedStore: t.unknown,
//   thing: t.boolean,
// }));
//
// export const RequestStoreChange = MessageDefinition.new("RequestStoreChange", t.type({
//   instanceId: t.string,
//   storeKey: t.string,
//   storeValue: t.unknown, // TODO - Need to do validation of this value at some point. Probably need to decode the storeValue based on the decoder from the storeKey, which means the store type needs to be a little more complex.
//   invalid: t.boolean,
// }));
//# sourceMappingURL=EntityManagementMessages.js.map